module.exports = __webpack_public_path__ + "img/company35.0f6c30d1.png";